import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Form from './Form';

export default function Popup({ manager, closeForm }) {
  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={manager != null}
      onHide={closeForm}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Invite
          {' '}
          {manager ? manager.attributes.full_name : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form closeForm={closeForm} manager={manager} />
      </Modal.Body>
    </Modal>
  );
}
